import React, { useEffect, Suspense, Fragment } from 'react';
import { Loading, DoubleSidedImage } from 'components/shared';
import { toast, Notification } from 'components/ui';
import { useDispatch, useSelector } from 'react-redux';
import reducer from './store';
import { injectReducer } from 'store/index';
import { Container } from 'components/shared';
import { useNavigate } from 'react-router-dom';
import { getSocialNetwork, updateSocialNetwork } from './store/dataSlice';
import SocialNetworkForm from 'views/socialnetwork/SocialNetworkForm';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import { getSocialNetworkList } from '../SocialNetworkList/store/dataSlice';
import { setDialog } from '../SocialNetworkForm/store/dataSlice';

injectReducer('SocialNetworkEdit', reducer)

const SocialNetworkEdit = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const socialData = useSelector((state) => state.SocialNetworkEdit.data.productData);
	const loading = useSelector((state) => state.SocialNetworkEdit.data.loading);
	const selectedLanguage = useSelector((state) => state.selectLang.data.selectedLanguage);
	const multiLang = useSelector((state) => state.selectLang.data.multiLang);
	const selectedData = useSelector((state) => state.socialnetworksList.state.selectedProduct)
	const tableData = useSelector((state) => state.socialnetworksList.data.tableData)

	const fetchData = (data) => {
		dispatch(getSocialNetwork(data));
	}

	const handleFormSubmit = async (values, setSubmitting) => {
		setSubmitting(true)
		const updatedValues = {
			...values,
			webMultiLang: multiLang,
			languageId: selectedLanguage,
		};
		const success = await updateSocialNetwork(updatedValues)
		setSubmitting(false)
		if (success) {
			const updatedTableData = { ...tableData, webLangId: selectedLanguage };
			dispatch(getSocialNetworkList(updatedTableData));
			popNotification('account')
		}
	}

	const handleDiscard = () => {
		dispatch(setDialog(true));
	}

	const { t } = useTranslation();

	const popNotification = () => {
		toast.push(
			<Notification className="mr-2 mb-2" title={t('toast.updateSuccess')} type="success" duration={1000} />
		)
		navigate('/cms/SocialNetwork')
	}

	useEffect(() => {
		if (selectedData && selectedLanguage) {
			const rquestParam = { id: selectedData, webLangId: selectedLanguage }
			fetchData(rquestParam);
		}
	}, [selectedData, selectedLanguage])

	return (
		<Fragment>
			<Loading loading={loading}>
				{!isEmpty(socialData) && (
					<Container>
						<Suspense fallback={<Fragment></Fragment>}>
							<SocialNetworkForm
								type="edit"
								initialData={socialData}
								onFormSubmit={handleFormSubmit}
								onDiscard={handleDiscard}
							/>
						</Suspense>
					</Container>
				)}
			</Loading>
			{(!loading && isEmpty(socialData)) && (
				<div className="h-full flex flex-col items-center justify-center">
					<DoubleSidedImage
						src="/img/others/img-2.png"
						darkModeSrc="/img/others/img-2-dark.png"
						alt={t('translation.notFound')}
					/>
					<h3 className="mt-8">{t('translation.notFound')}</h3>
				</div>
			)}
		</Fragment>
	)
}

export default SocialNetworkEdit